import { Controller } from "@hotwired/stimulus"

// Validates the manual edit table rows in real-time.
// Enables the submit button only when ALL rows have all selects filled.
export default class extends Controller {
  static targets = ["row", "submitBtn", "validCount", "totalCount"]

  connect() {
    this.validate()
  }

  validate() {
    let filled = 0
    const total = this.rowTargets.length

    this.rowTargets.forEach(row => {
      const selects = row.querySelectorAll("select")
      const allFilled = Array.from(selects).every(s => s.value !== "")

      row.dataset.valid = allFilled
      if (allFilled) filled++
    })

    this.submitBtnTarget.disabled = total === 0
    this.validCountTarget.textContent = filled
    this.totalCountTarget.textContent = total
  }
}
